import { render, staticRenderFns } from "./CoverPageBlock.vue?vue&type=template&id=09aed5b0&scoped=true&"
import script from "./CoverPageBlock.vue?vue&type=script&lang=ts&"
export * from "./CoverPageBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CoverPageBlock.vue?vue&type=style&index=0&id=09aed5b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aed5b0",
  null
  
)

export default component.exports